// extracted by mini-css-extract-plugin
module.exports = {"info":"styles_info__2eEWO","metaItem":"styles_metaItem__1MI3-","description":"styles_description__3crnz"};